import CallUs from '../shared/call-us/CallUs';

const FooterColumn = (section) => {
  const items = section.items ?? [];
  
  return (
    <div className="footer-column mb-3">
      <h5 className="mb-3">{section.header}</h5>
      <ul className="list-unstyled">
        {items.map((item, index) => (
          <li key={index} className="mb-2">
            {item.type === 'img-button' ? (
              <a href={item.href} className="d-flex align-items-center" target={item.target || '_self'}>
                <img
                  src={item.src}
                  alt={item.alt || ''}
                  style={{ maxHeight: item.maxHeight || '100%' }}
                  className="img-fluid"
                />
                {item.text && <span className="ms-2">{item.text}</span>}
              </a>
            ) : item.type === 'phone' ? (
              <CallUs 
                src={item.src}
                text={item.text}
                phoneNumber={item.phoneNumber}
                alt={item.alt}
                maxHeight={item.maxHeight}
              />
            ) : item.type === 'deliveries' ? (
              <button className="btn btn-link p-0 deliveries-link" data-bs-toggle="modal" data-bs-target="#deliveriesModal" style={{textDecoration: 'none', color: 'inherit'}}>{item.text}</button>
            ) : (
              <a href={item.href} target={item.target || '_self'}>{item.text}</a>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
};
const Footer = (footer) => {
  const sections = footer.sections ?? [];
  const currentYear = new Date().getFullYear();
  return (
    <footer className="footer mt-auto pb-2 py-5">
      <div className="container">
        <div className="row">
          {sections.map((section, index) => (
            <div className="col-12 col-md" key={index}>
              <FooterColumn {...section} />
            </div>
          ))}
        </div>
        <div className="row h-auto">
          <div className="col text-center mt-4">
            <span>Copyright © Digital Facilities Corporation 2002 - {currentYear}</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;